// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* TV-optimized Job Display Styling */
.job-display {
    min-height: 100vh;
    overflow-x: hidden;
}

/* ===== BLACKSCREEN MODE (Nachtruhe) ===== */
.black-mode {
    /* fixed über den ganzen Viewport, damit body-Padding/-Hintergrund nicht durchscheint */
    position: fixed;
    inset: 0;
    z-index: 1000;
    background: #000;
    display: flex;
    justify-content: center;
    align-items: center;
}

.black-mode-time {
    color: #333;
    font-size: 20vw;
    font-weight: normal;
    letter-spacing: 0.1em;
    font-variant-numeric: tabular-nums;
}

/* ===== COUNTDOWN MODE ===== */
.countdown-mode {
    display: flex;
    justify-content: center;
    align-items: center;
}

.countdown-container {
    text-align: center;
    padding: 2rem;
}

.current-time {
    font-size: 8rem;
    font-weight: normal;
    letter-spacing: 0.1em;
    margin-bottom: 2rem;
    font-variant-numeric: tabular-nums;
}

.next-einheit-label {
    font-size: 2rem;
    text-transform: uppercase;
    letter-spacing: 0.3em;
    opacity: 0.7;
    margin-bottom: 0.5rem;
}

.next-einheit-name {
    font-size: 4rem;
    font-weight: normal;
    margin-bottom: 2rem;
}

.countdown-timer {
    font-size: 5rem;
    font-weight: normal;
    background: linear-gradient(135deg, #00f2fe 0%, #4facfe 100%);
    -webkit-background-clip: text;
    background-clip: text;
    text-shadow: none;
    font-variant-numeric: tabular-nums;
    animation: pulse 2s ease-in-out infinite;
}

@keyframes pulse {

    0%,
    100% {
        opacity: 1;
        transform: scale(1);
    }

    50% {
        opacity: 0.9;
        transform: scale(1.02);
    }
}

.countdown-label {
    font-size: 1.8rem;
    text-transform: uppercase;
    letter-spacing: 0.2em;
    opacity: 0.6;
    margin-top: 1rem;
}

.no-einheit-message {
    font-size: 3rem;
    opacity: 0.5;
    margin-top: 2rem;
}

/* ===== EINHEIT DISPLAY MODE ===== */
.einheit-mode {
    padding: 1rem;
}

.einheit-header {
    text-align: center;
    padding: 1.5rem;
    margin-bottom: 1rem;
    background: var(--dunkelgruen);
    border-radius: 1rem;
    backdrop-filter: blur(10px);
}

.einheit-header h1 {
    font-size: 4rem;
    font-weight: normal;
    margin: 0;
    color: var(--weiss);
    text-shadow: 0 4px 8px rgba(0, 0, 0, 0.4);
}

.einheit-time {
    font-size: 2rem;
    margin-top: 0.5rem;
    color: var(--weiss);
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.35);
}

/* ===== EINHEIT DISPLAY MODE — horizontales Laufband (Sealife-Style) ===== */
.einheit-mode-h {
    height: 100vh;
    overflow: hidden;
    padding: 1rem;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
}

.marquee-viewport {
    flex: 1 1 auto;
    width: 100%;
    overflow: hidden;
    position: relative;
}

.marquee-track {
    display: flex;
    flex-wrap: nowrap;
    align-items: flex-start;
    width: max-content;
    height: 100%;
}

/* Wenige Zelte (<=3): zentriert, kein Scrollen */
.marquee-track.centered {
    width: 100%;
    justify-content: center;
    gap: 1.5vw;
}

/* Viele Zelte: nahtloser Endlos-Lauf nach links (Inhalt ist verdoppelt) */
.marquee-track.animate {
    animation-name: marquee-scroll-left;
    animation-timing-function: linear;
    animation-iteration-count: infinite;
    will-change: transform;
}

@keyframes marquee-scroll-left {
    from { transform: translateX(0); }
    to   { transform: translateX(-50%); }
}

.zelt-card {
    flex: 0 0 auto;
    width: 31vw;
    /* 3 Karten (3 x 31vw) + Abstände passen nebeneinander; die 4. lugt rechts herein */
    max-height: 100%;
    background: rgba(255, 255, 255, 0.95);
    border-radius: 1rem;
    overflow: hidden;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
}

/* Gleichmäßiger Abstand pro Karte -> translateX(-50%) loopt exakt lückenlos */
.marquee-track.animate .zelt-card {
    margin-right: 1.5vw;
}

.zelt-name {
    background: var(--dunkelgruen);
    font-size: 1.8rem;
    font-weight: normal;
    padding: 1rem 1.5rem;
    margin: 0;
    text-align: center;
    color: var(--weiss);
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.kinder-table {
    width: 100%;
    border-collapse: collapse;
}

.kinder-table th {
    background: #f0f0f0;
    padding: 0.8rem 1rem;
    text-align: left;
    font-size: 1.2rem;
    font-weight: normal;
    color: #333;
    border-bottom: 2px solid #ddd;
}

.kinder-table td {
    padding: 0.8rem 1rem;
    font-size: 1.3rem;
    border-bottom: 1px solid #eee;
}

.kinder-table tr:nth-child(even) {
    background: #f9f9f9;
}

.kinder-table tr:hover {
    background: #e8f4ff;
}

.kinder-table td:first-child {
    font-weight: normal;
    color: #333;
}

.kinder-table td:last-child {
    color: #333;
    font-weight: normal;
}

.no-data-message {
    text-align: center;
    font-size: 2.5rem;
    color: rgba(255, 255, 255, 0.7);
    padding: 4rem;
}

/* ===== RESPONSIVE ADJUSTMENTS ===== */
@media (max-width: 1200px) {
    .current-time {
        font-size: 5rem;
    }

    .countdown-timer {
        font-size: 6rem;
    }

    .next-einheit-name {
        font-size: 3rem;
    }

    .einheit-header h1 {
        font-size: 3rem;
    }
}

@media (max-width: 768px) {
    .current-time {
        font-size: 3rem;
    }

    .countdown-timer {
        font-size: 4rem;
    }

    .next-einheit-name {
        font-size: 2rem;
    }

    .einheit-header h1 {
        font-size: 2rem;
    }

    .zelt-name {
        font-size: 1.4rem;
    }

    .kinder-table td,
    .kinder-table th {
        font-size: 1rem;
        padding: 0.6rem;
    }
}`, "",{"version":3,"sources":["webpack://./src/display/JobDisplay.css"],"names":[],"mappings":"AAAA,qCAAqC;AACrC;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA,6CAA6C;AAC7C;IACI,uFAAuF;IACvF,eAAe;IACf,QAAQ;IACR,aAAa;IACb,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,mBAAmB;IACnB,qBAAqB;IACrB,kCAAkC;AACtC;;AAEA,+BAA+B;AAC/B;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,qBAAqB;IACrB,mBAAmB;IACnB,kCAAkC;AACtC;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,qBAAqB;IACrB,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,6DAA6D;IAC7D,6BAA6B;IAC7B,qBAAqB;IACrB,iBAAiB;IACjB,kCAAkC;IAClC,wCAAwC;AAC5C;;AAEA;;IAEI;;QAEI,UAAU;QACV,mBAAmB;IACvB;;IAEA;QACI,YAAY;QACZ,sBAAsB;IAC1B;AACJ;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,qBAAqB;IACrB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,gBAAgB;AACpB;;AAEA,qCAAqC;AACrC;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,SAAS;IACT,mBAAmB;IACnB,yCAAyC;AAC7C;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,0CAA0C;AAC9C;;AAEA,6EAA6E;AAC7E;IACI,aAAa;IACb,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,uBAAuB;IACvB,kBAAkB;IAClB,YAAY;AAChB;;AAEA,iDAAiD;AACjD;IACI,WAAW;IACX,uBAAuB;IACvB,UAAU;AACd;;AAEA,0EAA0E;AAC1E;IACI,mCAAmC;IACnC,iCAAiC;IACjC,mCAAmC;IACnC,sBAAsB;AAC1B;;AAEA;IACI,OAAO,wBAAwB,EAAE;IACjC,OAAO,2BAA2B,EAAE;AACxC;;AAEA;IACI,cAAc;IACd,WAAW;IACX,mFAAmF;IACnF,gBAAgB;IAChB,qCAAqC;IACrC,mBAAmB;IACnB,gBAAgB;IAChB,yCAAyC;AAC7C;;AAEA,8EAA8E;AAC9E;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;IAC9B,iBAAiB;IACjB,mBAAmB;IACnB,oBAAoB;IACpB,SAAS;IACT,kBAAkB;IAClB,mBAAmB;IACnB,yCAAyC;AAC7C;;AAEA;IACI,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,WAAW;IACX,6BAA6B;AACjC;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,+BAA+B;IAC/B,aAAa;AACjB;;AAEA,uCAAuC;AACvC;IACI;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;;QAEI,eAAe;QACf,eAAe;IACnB;AACJ","sourcesContent":["/* TV-optimized Job Display Styling */\n.job-display {\n    min-height: 100vh;\n    overflow-x: hidden;\n}\n\n/* ===== BLACKSCREEN MODE (Nachtruhe) ===== */\n.black-mode {\n    /* fixed über den ganzen Viewport, damit body-Padding/-Hintergrund nicht durchscheint */\n    position: fixed;\n    inset: 0;\n    z-index: 1000;\n    background: #000;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.black-mode-time {\n    color: #333;\n    font-size: 20vw;\n    font-weight: normal;\n    letter-spacing: 0.1em;\n    font-variant-numeric: tabular-nums;\n}\n\n/* ===== COUNTDOWN MODE ===== */\n.countdown-mode {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.countdown-container {\n    text-align: center;\n    padding: 2rem;\n}\n\n.current-time {\n    font-size: 8rem;\n    font-weight: normal;\n    letter-spacing: 0.1em;\n    margin-bottom: 2rem;\n    font-variant-numeric: tabular-nums;\n}\n\n.next-einheit-label {\n    font-size: 2rem;\n    text-transform: uppercase;\n    letter-spacing: 0.3em;\n    opacity: 0.7;\n    margin-bottom: 0.5rem;\n}\n\n.next-einheit-name {\n    font-size: 4rem;\n    font-weight: normal;\n    margin-bottom: 2rem;\n}\n\n.countdown-timer {\n    font-size: 5rem;\n    font-weight: normal;\n    background: linear-gradient(135deg, #00f2fe 0%, #4facfe 100%);\n    -webkit-background-clip: text;\n    background-clip: text;\n    text-shadow: none;\n    font-variant-numeric: tabular-nums;\n    animation: pulse 2s ease-in-out infinite;\n}\n\n@keyframes pulse {\n\n    0%,\n    100% {\n        opacity: 1;\n        transform: scale(1);\n    }\n\n    50% {\n        opacity: 0.9;\n        transform: scale(1.02);\n    }\n}\n\n.countdown-label {\n    font-size: 1.8rem;\n    text-transform: uppercase;\n    letter-spacing: 0.2em;\n    opacity: 0.6;\n    margin-top: 1rem;\n}\n\n.no-einheit-message {\n    font-size: 3rem;\n    opacity: 0.5;\n    margin-top: 2rem;\n}\n\n/* ===== EINHEIT DISPLAY MODE ===== */\n.einheit-mode {\n    padding: 1rem;\n}\n\n.einheit-header {\n    text-align: center;\n    padding: 1.5rem;\n    margin-bottom: 1rem;\n    background: var(--dunkelgruen);\n    border-radius: 1rem;\n    backdrop-filter: blur(10px);\n}\n\n.einheit-header h1 {\n    font-size: 4rem;\n    font-weight: normal;\n    margin: 0;\n    color: var(--weiss);\n    text-shadow: 0 4px 8px rgba(0, 0, 0, 0.4);\n}\n\n.einheit-time {\n    font-size: 2rem;\n    margin-top: 0.5rem;\n    color: var(--weiss);\n    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.35);\n}\n\n/* ===== EINHEIT DISPLAY MODE — horizontales Laufband (Sealife-Style) ===== */\n.einheit-mode-h {\n    height: 100vh;\n    overflow: hidden;\n    padding: 1rem;\n    box-sizing: border-box;\n    display: flex;\n    flex-direction: column;\n}\n\n.marquee-viewport {\n    flex: 1 1 auto;\n    width: 100%;\n    overflow: hidden;\n    position: relative;\n}\n\n.marquee-track {\n    display: flex;\n    flex-wrap: nowrap;\n    align-items: flex-start;\n    width: max-content;\n    height: 100%;\n}\n\n/* Wenige Zelte (<=3): zentriert, kein Scrollen */\n.marquee-track.centered {\n    width: 100%;\n    justify-content: center;\n    gap: 1.5vw;\n}\n\n/* Viele Zelte: nahtloser Endlos-Lauf nach links (Inhalt ist verdoppelt) */\n.marquee-track.animate {\n    animation-name: marquee-scroll-left;\n    animation-timing-function: linear;\n    animation-iteration-count: infinite;\n    will-change: transform;\n}\n\n@keyframes marquee-scroll-left {\n    from { transform: translateX(0); }\n    to   { transform: translateX(-50%); }\n}\n\n.zelt-card {\n    flex: 0 0 auto;\n    width: 31vw;\n    /* 3 Karten (3 x 31vw) + Abstände passen nebeneinander; die 4. lugt rechts herein */\n    max-height: 100%;\n    background: rgba(255, 255, 255, 0.95);\n    border-radius: 1rem;\n    overflow: hidden;\n    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);\n}\n\n/* Gleichmäßiger Abstand pro Karte -> translateX(-50%) loopt exakt lückenlos */\n.marquee-track.animate .zelt-card {\n    margin-right: 1.5vw;\n}\n\n.zelt-name {\n    background: var(--dunkelgruen);\n    font-size: 1.8rem;\n    font-weight: normal;\n    padding: 1rem 1.5rem;\n    margin: 0;\n    text-align: center;\n    color: var(--weiss);\n    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n}\n\n.kinder-table {\n    width: 100%;\n    border-collapse: collapse;\n}\n\n.kinder-table th {\n    background: #f0f0f0;\n    padding: 0.8rem 1rem;\n    text-align: left;\n    font-size: 1.2rem;\n    font-weight: normal;\n    color: #333;\n    border-bottom: 2px solid #ddd;\n}\n\n.kinder-table td {\n    padding: 0.8rem 1rem;\n    font-size: 1.3rem;\n    border-bottom: 1px solid #eee;\n}\n\n.kinder-table tr:nth-child(even) {\n    background: #f9f9f9;\n}\n\n.kinder-table tr:hover {\n    background: #e8f4ff;\n}\n\n.kinder-table td:first-child {\n    font-weight: normal;\n    color: #333;\n}\n\n.kinder-table td:last-child {\n    color: #333;\n    font-weight: normal;\n}\n\n.no-data-message {\n    text-align: center;\n    font-size: 2.5rem;\n    color: rgba(255, 255, 255, 0.7);\n    padding: 4rem;\n}\n\n/* ===== RESPONSIVE ADJUSTMENTS ===== */\n@media (max-width: 1200px) {\n    .current-time {\n        font-size: 5rem;\n    }\n\n    .countdown-timer {\n        font-size: 6rem;\n    }\n\n    .next-einheit-name {\n        font-size: 3rem;\n    }\n\n    .einheit-header h1 {\n        font-size: 3rem;\n    }\n}\n\n@media (max-width: 768px) {\n    .current-time {\n        font-size: 3rem;\n    }\n\n    .countdown-timer {\n        font-size: 4rem;\n    }\n\n    .next-einheit-name {\n        font-size: 2rem;\n    }\n\n    .einheit-header h1 {\n        font-size: 2rem;\n    }\n\n    .zelt-name {\n        font-size: 1.4rem;\n    }\n\n    .kinder-table td,\n    .kinder-table th {\n        font-size: 1rem;\n        padding: 0.6rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
